import { useGetAccounts } from '@api/lendingAPI/lapiHooks';
import { FormattedMessage } from 'react-intl';

import messages from './FundingProgressIndicator.messages';
import {
    Step,
    StepIndicator,
    StepLabel
} from '../../../ui/components/ProgressBar/StepIndicator';

export const FundingProgressIndicator = ({ step }: { step: number }) => {
    const { data, isLoading, isError } = useGetAccounts();

    if (isLoading || isError) return null;

    const { accounts } = data;

    if (accounts.length === 0) return null;

    const isTopup =
        accounts.filter(
            (account) => account.loan_status && account.loan_status !== 'ended'
        ).length !== 0;

    return (
        <StepIndicator className="mb-3xl">
            <Step isActive={step === 1} isComplete={step > 1}>
                <StepLabel>
                    {isTopup ? (
                        <FormattedMessage {...messages.selectAmountLabel} />
                    ) : (
                        <FormattedMessage {...messages.loanDetailsLabel} />
                    )}
                </StepLabel>
            </Step>
            <Step isActive={step === 2} isComplete={step > 2}>
                <StepLabel>
                    <FormattedMessage {...messages.finalChecksLabel} />
                </StepLabel>
            </Step>
            <Step isActive={step === 3}>
                <StepLabel>
                    <FormattedMessage {...messages.withdrawFundsLabel} />
                </StepLabel>
            </Step>
        </StepIndicator>
    );
};
